import { useState } from "react";
import { BaseModal } from "./BaseModal";

const DAY_LABELS = {
  SUNDAY: "Sun",
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
};

const DAY_ORDER = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

export function ClearDayModal({ isOpen, onClose, onClear, populatedDays }) {
  const [selectedDays, setSelectedDays] = useState([]);

  const toggleDay = (dayCode) => {
    setSelectedDays((prev) =>
      prev.includes(dayCode) ? prev.filter((d) => d !== dayCode) : [...prev, dayCode]
    );
  };

  const handleClear = () => {
    onClear(selectedDays);
    setSelectedDays([]);
    onClose();
  };

  const handleClose = () => {
    setSelectedDays([]);
    onClose();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Clear Days"
      subtitle="Select the days you want to clear. This cannot be undone."
      footer={
        <>
          <button
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleClear}
            disabled={selectedDays.length === 0}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Clear {selectedDays.length > 0 ? `${selectedDays.length} day${selectedDays.length > 1 ? "s" : ""}` : "Selected"}
          </button>
        </>
      }
    >
      <div className="flex flex-wrap gap-2">
        {DAY_ORDER.map((dayCode) => {
          const isPopulated = populatedDays.has(dayCode);
          const isSelected = selectedDays.includes(dayCode);
          return (
            <button
              key={dayCode}
              type="button"
              onClick={() => isPopulated && toggleDay(dayCode)}
              disabled={!isPopulated}
              className={`
                px-4 py-2 rounded-full text-sm font-medium transition-colors
                ${isSelected
                  ? "bg-red-600 text-white border border-red-600"
                  : isPopulated
                    ? "bg-white text-gray-700 border border-gray-200 hover:border-gray-400"
                    : "bg-gray-50 text-gray-300 border border-gray-100 cursor-not-allowed"
                }
              `}
            >
              {DAY_LABELS[dayCode]}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-gray-400 mt-3">Greyed out days have no meals planned.</p>
    </BaseModal>
  );
}
